export default "__VITE_ASSET__CIwiXtaV__"